import { render, staticRenderFns } from "./ReferralTableList.vue?vue&type=template&id=f95fef4e"
import script from "./ReferralTableList.vue?vue&type=script&lang=ts"
export * from "./ReferralTableList.vue?vue&type=script&lang=ts"
import style0 from "./ReferralTableList.vue?vue&type=style&index=0&id=f95fef4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports